import Wysiwyg from "components/type/Wysiwyg"
import PropTypes from "prop-types"
import React from "react"
import { AnnouncementCarousel } from "./AnnouncementCarousel"
import "./topbar.scss"

const TopBar = ({ announcement }) => {
  return (
    <header className="topbar-container">
      <div className="container-v2">
        {announcement && <AnnouncementCarousel announcement={announcement} />}
      </div>
    </header>
  )
}

TopBar.propTypes = {
  announcement: PropTypes.shape(Wysiwyg.props),
}

export default TopBar
// <div className="top-bar-container">
//       TopBar {JSON.stringify(announcement, null, 2)}
//     </div>
